import { shallow } from '@awning/archie';
import { Box, Text } from '@awning/components';
import { STATE_NAMES } from 'STATES';
import { toPercentString } from '@/src/utils';
import { useMarketInsightsStore } from './store';
import { MaskedData } from '../MaskedData/MaskedData';

const getLongStateName = (stateId: string) =>
  ((STATE_NAMES as any)[stateId.toUpperCase()] ?? stateId) as string;

export const OccupancyTabSummary = () => {
  const { q, occupancy } = useMarketInsightsStore(
    state => ({
      occupancy: state.marketInsights.occupancy,
      q: state.q,
    }),
    shallow
  );
  const location = q.split('--');
  const placeLongName = location?.[0];
  const shortStateName = location?.[1];

  const stateName = getLongStateName(shortStateName);

  // example: The average airbnb occupancy rate in San Francisco, CA is 83% for entire homes, 65% for private rooms, and 21% for shared rooms.
  return (
    <Box sx={{ marginTop: 4, marginBottom: 4 }}>
      <Text sx={{ display: 'block', fontWeight: 'bold', marginTop: 6, marginBottom: 4 }}>
        Occupancy
      </Text>
      <Box sx={{ text: 'xs', color: 'gray.500' }}>
        <p>
          The average airbnb occupancy rate in {placeLongName}, {stateName} is{' '}
          {toPercentString(occupancy.entireHome)} for entire homes
          <span>
            {occupancy.privateRoom && occupancy.sharedRoom ? (
              <span>
                , <MaskedData>{toPercentString(occupancy.privateRoom)}</MaskedData> for private
                rooms, and <MaskedData>{toPercentString(occupancy.sharedRoom)}</MaskedData> for
                shared rooms.
              </span>
            ) : (
              '.'
            )}
          </span>{' '}
        </p>
      </Box>
    </Box>
  );
};
